// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
    <sub-header header="\$ctrl.description"></sub-header>
    <div class="alert-container">
      <div class="alert alert--danger" ng-if="\$ctrl.displayEmptyReceiptMessage">
        <span>User has no available invoice</span>
      </div>
    </div>
    <h2 class="section-header">{{ \$ctrl.title }}</h2>
    <form name="\$ctrl.transactionForm">
      <table class="misc-transaction__table table table--generate-row-ids">
        <h2>Invoice data:</h2>
        <tbody>
          <tr>
            <td></td>
            <td>Invoice number:</td>
            <td>
              <input
                type="text"
                ng-model="\$ctrl.transaction.receiptNo"
                ng-disabled="\$ctrl.autoReceiptEnabled"
                ng-required="true"/>
            </td>
          </tr>
          <tr>
            <td></td>
            <td>Category:</td>
            <td>
              <gl-category-select
                required
                action-type="\$ctrl.fullActionCode"
                is-selectize="true"
                ng-model="\$ctrl.category"
                single-accounts-only = "false"
                ng-change="\$ctrl.onCategoryChange()"
              >
              </gl-category-select>
            </td>
          </tr>
          <tr>
          <tr ng-if="!\$ctrl.isLedgerAccountSpecified()">
            <td></td>
            <td>Total amount:</td>
            <td>
              <cash value="\$ctrl.transaction.amount"
                ng-required="true"
                ng-disabled="true"></cash>
            </td>
          </tr>
          <tr ng-if="\$ctrl.isLedgerAccountSpecified()">
            <td></td>
            <td>Amount:</td>
            <td>
              <cash ng-model="\$ctrl.transaction.amount"
                    ng-disabled="true"
                    ng-required="true"></cash>
            </td>
          </tr>
          <tr>
            <td></td>
            <td>Name:</td>
            <td>
              <input
                type="text"
                ng-model="\$ctrl.transaction.customerName"
                required/>
            </td>
          </tr>
          <tr>
            <td></td>
            <td>Address:</td>
            <td>
              <input
                type="text"
                ng-model="\$ctrl.transaction.customerAddress"
                required/>
            </td>
          </tr>
          <tr>
            <td></td>
            <td>Payment for:</td>
            <td>
              <input
                type="text"
                ng-model="\$ctrl.transaction.receiptSubject"
                ng-required="true"/>
            </td>
          </tr>
          <tr ng-if="\$ctrl.interbranch">
            <td></td>
            <td>Target branch:</td>
            <td>
              <selectize
              options="\$ctrl.otherBranches"
              ng-model="\$ctrl.transaction.targetBranchId"
              config="\$ctrl.targetBranchSelectConfig"
              class="nx-selectize"
              required
            >
            </selectize>
            </td>
          </tr>
          <tr>
            <td></td>
            <td>Remarks:</td>
            <td>
              <input
                type="text"
                maxlength="512"
                ng-model="\$ctrl.transaction.remarks"
                ng-required="\$ctrl.remarksRequired"/>
            </td>
          </tr>
          <tr ng-if="\$ctrl.transaction.amount > \$ctrl.cashReceiptThreshold">
            <td></td>
            <td>(AMLA) Clients first and last name:</td>
            <td>
              <input
                type="text"
                ng-model="\$ctrl.transaction.customerName"
                ng-required="true"/>
            </td>
          </tr>
          <tr ng-if="\$ctrl.transaction.amount > \$ctrl.cashReceiptThreshold">
            <td></td>
            <td>(AMLA) Clients address:</td>
            <td>
              <input
                type="text"
                ng-model="\$ctrl.transaction.customerAddress"
                ng-required="true"/>
            </td>
          </tr>
        </tbody>
      </table>

      <div ng-if="\$ctrl.isOfficialReceiptInCheck()">
        <h2>Check data:</h2>
        <check-form
          check-model="\$ctrl.transaction"
          entry-type="'CREDIT'"
          disable-amount-input="true"
          without-remarks="true"
          on-us-check-allowed="true">
        </check-form>
      </div>

      <div>
        <h2>GL transaction data:</h2>
        <ledger-units
          units="\$ctrl.units"
          entry-type="\$ctrl.entryType"
          amount="\$ctrl.transaction.amount"
          fixed-account-label="\$ctrl.fixedAccountLabel"
          blocked-units="\$ctrl.blockedUnits"
          hide-contingent="true">
        </ledger-units>
      </div>

      <div class="buttons">
        <button type="button"
          class="misc-transaction__cancel btn btn-warning"
          ng-disabled="\$ctrl.transactionForm.\$pristine"
          ng-click="\$ctrl.cancelChanges()">
          Cancel
        </button>
        <button
          type="submit"
          class="misc-transaction__save btn btn-success"
          ng-disabled="\$ctrl.transactionForm.\$invalid"
          ng-click="\$ctrl.save()">
          Pay now
        </button>
      </div>
    </form>
</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/dashboard/miscellaneous-transactions/official-receipt/official-receipt.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;